import React from "react";

import { Route, Routes } from "react-router-dom";

import AuthOrApp from "./AuthOrApp";
import PrivateRoutes from "./auth/PrivateRoutes";
import Bancarios from "./pages/Bancarios";
import Contas from "./pages/Contas";
import ContasDetalhe from "./pages/ContasDetalhe";
import CreateUser from "./pages/CreateUser";
import Extrato from "./pages/Extrato";
import Graficos from "./pages/Graficos";
import Home from "./pages/Home";
import PainelLowtax from "./pages/PainelLowtax";
import UpdateEmpresa from "./pages/UpdateEmpresa";
import Usuarios from "./pages/Usuarios";

function Router() {
  return (
    <Routes>
      <Route path="/" element={<AuthOrApp />} />
      <Route path="/home" element={<PrivateRoutes component={<Home />} />} />
      <Route
        path="/:id/details"
        element={<PrivateRoutes component={<Extrato />} />}
      />
      <Route
        path="/planoContas"
        element={<PrivateRoutes component={<Contas />} />}
      />
      <Route
        path="/:cnpj/contasDetalhe"
        element={<PrivateRoutes component={<ContasDetalhe />} />}
      />
      <Route
        path="/graficos"
        element={<PrivateRoutes component={<Graficos />} />}
      />
      <Route
        path="/createUser"
        element={<PrivateRoutes component={<CreateUser />} />}
      />
      <Route
        path="/painelLowtax"
        element={<PrivateRoutes component={<PainelLowtax />} />}
      />
      <Route
        path="/bancarios"
        element={<PrivateRoutes component={<Bancarios />} />}
      />
      <Route
        path="/updateEmpresa/:cnpj"
        element={<PrivateRoutes component={<UpdateEmpresa />} />}
      />
      <Route
        path="/usuarios"
        element={<PrivateRoutes component={<Usuarios />} />}
      />
    </Routes>
  );
}

export default Router;
